import { gql } from '@apollo/client';

export const CREATE_STANDARDIZED_ADDRESS_MANUALLY = gql`
  mutation CreateStandardizedAddressManually($input: CreateStandardizedAddressManualInput!) {
    createStandardizedAddressManually(input: $input) {
      success
      addressId
      errorMessage
    }
  }
`;

export interface CreateStandardizedAddressManualInput {
  street: string;
  city: string;
  state: string;
  zipcode: string;
  latitude: number;
  longitude: number;
}

export interface CreateStandardizedAddressManuallyResponse {
  createStandardizedAddressManually: {
    success: boolean;
    addressId: string | null;
    errorMessage: string | null;
  };
}

export interface CreateStandardizedAddressManuallyVariables {
  input: CreateStandardizedAddressManualInput;
}
